import React from "react";
import "../Styles/Home.css";

function Home() {
  return (
    <div className="home">
      <h1> Welcome To React Album </h1>
    </div>
  );
}

export default Home;
